import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {KlasifikatoriusApi} from "../api/klasifikatorius.api";
import {environment} from "../../environments/environment";
import {TabakoKlasifikatoriusApi} from "../api/tabako-klasifikatorius.api";
import {LanguageService} from "./language.service";

@Injectable({
  providedIn: 'root'
})
export class KlasifikatoriusService {

  private getKlasifikatoriusUrl = environment.apiBaseUrl + '/internalApi/getKlasifikatorius';
  private tabakoKlasifikatoriusUrl = environment.apiBaseUrl + '/internalApi/fetchTabakoKlasifikatorius';

  constructor(private http: HttpClient,
              private languageService: LanguageService) { }

  getKlasifikatorius(): Observable<KlasifikatoriusApi[]> {
    return this.http.get<KlasifikatoriusApi[]>(this.getKlasifikatoriusUrl, { withCredentials: true }).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  getTabakoKlasifikatorius(): Observable<TabakoKlasifikatoriusApi[]> {
    return this.http.get<TabakoKlasifikatoriusApi[]>(this.tabakoKlasifikatoriusUrl, { withCredentials: true }).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }

  prepareClFilterList(klasifikatoriusList: KlasifikatoriusApi[], clCode: string, clReikmeCode?: string): { value: any; text: string }[] {
    const emptySelection = { value: '', text: '' };
    const klasifiers = klasifikatoriusList
      .filter(item => item.kodas === clCode)
      .flatMap(item => item.klasifikatoriausReiksmeApiList ?? [])
      .filter(k => clReikmeCode ? k.kodas === clReikmeCode : true)
      .map(k => ({ value: k.id, text: this.languageService.translatePavadinimas(k.pavadinimas) }));
    return [emptySelection, ...klasifiers];
  }
}
